<template>
    <div>
        <Banner></Banner>
        <BannerNav></BannerNav>
        <div class="center-content">
            <menu-page>
                <div class="menu-left" slot="menuList">
                    <div class="menu-left-con">
                        <img src="../../assets/gongxu_icon_xuqiuxinxi@3x.png" alt="" />
                        <div class="menu-left-con-title">IP政策法律</div>
                    </div>
                    <el-menu :default-active="flag" @select="handleSelect">
                        <el-menu-item index="1">通知公告</el-menu-item>
                        <el-menu-item index="2">新闻资讯</el-menu-item>
                        <el-menu-item index="3">政策法规</el-menu-item>
                    </el-menu>
                </div>

                <div class="main">
                    <div v-if="flag == 1">
                        <news-dynamic></news-dynamic>
                    </div>
                    <div v-else-if="flag == 2">
                        <news-field></news-field>
                    </div>
                    <div v-else>
                        <news-dynamics></news-dynamics>
                    </div>
                </div>
            </menu-page>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import BreadPage from '../../components/page/BreadPage.vue';
import MenuPage from '../../components/page/MenuPage.vue';
import Banner from '../../components/Banner.vue';
import BannerNav from '../../components/BannerNav.vue';
import newsDynamic from '../../components/newsDynamic.vue';
import newsField from '../../components/newsField.vue';
import newsDynamics from '../../components/newsDynamics.vue';
import menu from '../../mixins/menu';
export default {
    components: { MenuPage, newsField, newsDynamic, newsDynamics, Banner, BannerNav },
    mixins: [menu],
    data() {
        return {
            flag: 1
        };
    },
    computed: {
        ...mapState(['adminleftnavnum'])
    },
    watch: {
        '$store.state.flag': {
            handler(val) {
                if (val) {
                    this.flag = this.$store.state.flag;
                }
            },
            immediate: true
        },
        watch: {
            $route() {
                this.scrollTo();
            }
        }
    },
    methods: {
        handleSelect(key) {
            this.scrollTo(true);
            this.flag = key;
            this.$router.push('/newsList?flag=' + key);
        }
    },
    created() {
        if (this.$route.query.flag) {
            this.handleSelect(this.$route.query.flag);
        }
        this.scrollTo(true);
    }
};
</script>

<style lang="less" scoped>
.center-content {
    width: 100%;
    box-sizing: border-box;
    padding: 0 50px;
    max-width: 1300px;
    margin: 0 auto;
    margin-top: 63px;
}
.bread-page {
    background: linear-gradient(180deg, #009e40 0%, #fafafa 100%);
    background-size: 100% 300px;
    background-repeat: no-repeat;
}
.appContainer {
    background: #ffffff;
}
.menu-left {
    // min-height: 600px;
    width: 200px;
    height: 280px;
    background: #ffffff;
    box-shadow: 0px 0px 6px 0px #d2dbf0;
    .menu-left-con {
        height: 60px;
        background: #0092B1;
        display: flex;
        padding-left: 34px;
        align-items: center;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #ffffff;
        .menu-left-con-title {
            font-size: 16px;
            font-weight: bold;
        }
        img {
            width: 24px;
            height: 24px;
            margin-right: 10px;
        }
    }
}
.main {
    min-height: 900px;
    margin-top: -20px;
    flex-grow: 1;
    .flex-col();
}
/deep/ .el-menu-item {
    // text-align: center;
    // padding-right: 60px;
    padding-left: 68px !important;
}
/deep/ .el-menu > .el-menu-item {
    &.is-active {
        background: linear-gradient(90deg, #DFF0F6 0%, #FBFDFE 68%, #FFFFFF 100%);
        color: #0092B1;
        position: relative;
        font-weight: bold;
    }
    &.is-active::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        height: 60px;
        width: 1px;
        background-color: #0092B1;
    }
}
</style>

